import { Component } from '@angular/core';

@Component({
  selector: '[app-pet-footer]',
  templateUrl: './pet-footer.component.html',
  styleUrls: ['./pet-footer.component.css']
})
export class PetFooterComponent {

}
